
import { DNABox, DNAButton, DNAText, Iffy, Popover } from '@alucio/lux-ui'
import React from 'react'
import { StyleProp, ViewStyle } from 'react-native'
import { SidebarOptions, useContentViewerModalState } from '../../state/ContentViewerModalStateProvider'
import { tabConfigs } from '../SideBar'

interface ControlsProps {
  isUserDocument: boolean;
}

const Controls: React.FC<ControlsProps> = ({ isUserDocument }) => {
  const {
    visibleSidebar,
    setVisibleSidebar,
    getSidebarOptions,
    setVisibleSearch,
  } = useContentViewerModalState()
  const containerStyle: StyleProp<ViewStyle> = visibleSidebar
    ? {
      borderLeftWidth: 1,
      borderStyle: 'solid',
      borderColor: '#EBECF0',
    }
    : {}

  const buttons = getSidebarOptions()
    .map((optionId, idx) => {
      const config = tabConfigs.find((tab) => tab.id === optionId)
      if (isUserDocument && optionId !== SidebarOptions.notesSidebar) {
        return null;
      }
      if (!config)
      { throw Error(`Unknown tab ${optionId}`) }

      const buttonStyle: StyleProp<ViewStyle> = idx === 0
        ? { margin: 16, marginBottom: 12 }
        : { marginRight: 16, marginBottom: 12 }
      return (
        <Popover key={config.id} placement="left">
          <Popover.Anchor>
            <DNAButton
              status="flatAlt"
              context="round"
              iconLeft={config.icon}
              onPress={() => {
                setVisibleSidebar(config.id)
                setVisibleSearch(false);
              }}
              style={buttonStyle}
            />
          </Popover.Anchor>
          <Popover.Content>
            <DNAText
              style={{ color: 'white' }}
            >{config.label}</DNAText>
          </Popover.Content>
        </Popover>
      )
    })

  return (
    <DNABox
      appearance="col"
      alignX="end"
      style={containerStyle}
    >
      <Iffy is={visibleSidebar}>
        <DNAButton
          status="flatAlt"
          context="round"
          iconLeft="chevron-right"
          onPress={() => { setVisibleSidebar(undefined) }}
          style={{
            margin: 16,
            marginBottom: 12,
          }}
        />
      </Iffy>
      <Iffy is={!visibleSidebar}>
        {buttons}
      </Iffy>
    </DNABox>
  )
}

export default Controls
